import {Component} from "react";
import * as React from "react";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import TablePanel from "../../components/TablePanel";
import ImportPolozkyField from "./ImportPolozkyField";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Field array pro import fakturačních položek.
 */
class ImportPolozkyFieldArray extends Component<WithTranslation> {

    state = {
        activeIndex: null,
    };

    handlePolozkaClick = (index) => {
        this.setState({activeIndex: index});
    };

    render = () => {
        const {fields, t} = this.props;
        const {activeIndex} = this.state;
        return <Card>
            <CardHeader>
                {t('edit_item_hint')}
            </CardHeader>
            <CardBody>
                {fields.length > 0 ?
                    <TablePanel bordered header={
                        <Row>
                            <Col xs={3}>{t('file_name')}</Col>
                            <Col xs={1}>X</Col>
                            <Col xs={1}>Y</Col>
                            <Col xs={1}>{t('count')}</Col>
                            <Col xs={2}>{t('coverage')}</Col>
                            <Col xs={2}>{t('chromaticity')}</Col>
                            <Col xs={2}>{t('fold')}</Col>
                        </Row>
                    }>
                        {fields.map((field, index) => {
                            const polozka = fields.get(index);
                            return <ImportPolozkyField
                                key={index}
                                index={index}
                                field={field}
                                polozka={polozka}
                                isActive={index === activeIndex}
                                onClick={this.handlePolozkaClick}
                            />
                        })}
                    </TablePanel> : <i>{t('no_items')}</i>}
            </CardBody>
        </Card>
    };

}

export default withTranslation()(ImportPolozkyFieldArray);
